import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import {SelectField, TextField, TextAreaField} from 'components/Fields';

import {
  MODALS,
  fetchLegacyTypes,
  editLegacyDocument,
  fetchLegacyDocuments,
  selectBooking
} from 'ducks/bookings';
import {storeDataInModal, selectModal, closeModal} from 'ducks/modals';

import {headOption} from 'utils/common';

import ExifImage from 'components/ExifImage';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {bookingId} = props;
  const extraActions = [
    () => closeModal(MODALS.LEGACY_DOCUMENT_EDIT),
    () => fetchLegacyDocuments({bookingId})
  ];

  const data = {
    title: values.title,
    legacyType: _.get(values, 'legacyType.value'),
    notes: values.notes,
    documentId: props.legacyDocument.id
  };

  dispatch(editLegacyDocument(data, extraActions));
};

const DocumentPreview = ({document}) => (
  <div className="DocumentPreview colab-centered">
    <div className="documentContainer colab-centered">
      <ExifImage src={document.fileUrl} alt={document.name} />
    </div>
  </div>
);

const constructLegacyTypeSelectizeOption = legacyType => ({
  value: legacyType.id,
  label: legacyType.name
});

class LegacyDocumentEditForm extends React.Component<any> {
  state = {
    files: []
  };

  componentDidMount() {
    const extraActions = [
      legacyTypes =>
        storeDataInModal({
          modalName: MODALS.LEGACY_DOCUMENT_EDIT,
          data: {
            legacyTypes
          }
        })
    ];
    this.props.fetchLegacyTypes(extraActions);
  }

  render() {
    const {error, legacyTypes, legacyDocument} = this.props;

    return (
      <div className="LegacyDocumentEditForm">
        <form>
          {error && <ErrorBlock>{error}</ErrorBlock>}
          <div className="mainContainer">
            <div className="innerContainer">
              <FormField>
                <Label>Title</Label>
                <Field name="title" component={TextField} />
              </FormField>
              <FormField>
                <Label>Legacy Type</Label>
                <Field
                  name="legacyType"
                  component={SelectField}
                  options={legacyTypes.map(legacyType =>
                    constructLegacyTypeSelectizeOption(legacyType)
                  )}
                  disabled={legacyTypes.length === 1}
                />
              </FormField>
              <FormField className="notes">
                <Label>Notes</Label>
                <Field name="notes" component={TextAreaField} />
              </FormField>
            </div>
            <FormField className="innerContainer document">
              <Label>Document</Label>
              <DocumentPreview document={legacyDocument.document} />
            </FormField>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const booking = selectBooking(state);
  const {data: {legacyTypes, legacyDocument}} = selectModal(
    state,
    MODALS.LEGACY_DOCUMENT_EDIT
  );
  let legacyType: any = null;

  if (!_.isEmpty(legacyTypes)) {
    const selectedLegacyType = legacyTypes.filter(
      legacyType => legacyType.id === legacyDocument.legacyType.id
    );
    legacyType = headOption(
      selectedLegacyType,
      constructLegacyTypeSelectizeOption
    );
  }

  return {
    initialValues: {
      title: legacyDocument.title,
      legacyType,
      notes: legacyDocument.notes
    },
    bookingId: _.get(booking, 'id'),
    legacyDocument,
    legacyTypes: legacyTypes || []
  };
};

const mapDispatchToProps = {
  fetchLegacyTypes
};
const legacyDocumentEditForm = reduxForm({
  form: 'legacyDocumentEdit',
  onSubmit: formSubmit,
  enableReinitialize: true
})(LegacyDocumentEditForm);

export default connect(mapStateToProps, mapDispatchToProps)(
  legacyDocumentEditForm
);
